module.exports = __webpack_public_path__ + "img/30.b8b118d4.svg";